import { render, staticRenderFns } from "./box-input-font.vue?vue&type=template&id=acafb890&scoped=true&"
import script from "./box-input-font.vue?vue&type=script&lang=js&"
export * from "./box-input-font.vue?vue&type=script&lang=js&"
import style0 from "./box-input-font.vue?vue&type=style&index=0&id=acafb890&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acafb890",
  null
  
)

export default component.exports